module.exports = __webpack_public_path__ + "assets/img/66.8c324a36.png";